/**
 * @generated SignedSource<<49a7f88d38251a80918607940a973ced>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActivateBambooHRInput = {
  bambooDomain?: string | null;
  bambooApiKey?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ActivateBambooHRMutation$variables = {
  input: ActivateBambooHRInput;
};
export type ActivateBambooHRMutation$data = {
  readonly activateBambooHR: {
    readonly company: {
      readonly bambooHREnabled: boolean | null;
    } | null;
  } | null;
};
export type ActivateBambooHRMutation = {
  variables: ActivateBambooHRMutation$variables;
  response: ActivateBambooHRMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHREnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "activateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "activateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5e1a4d0dfab512947f2c5f4a64690627",
    "id": null,
    "metadata": {},
    "name": "ActivateBambooHRMutation",
    "operationKind": "mutation",
    "text": "mutation ActivateBambooHRMutation(\n  $input: ActivateBambooHRInput!\n) {\n  activateBambooHR(input: $input) {\n    company {\n      bambooHREnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0103a64b434db6fa83d7c81207b5ad85";

export default node;
